// extracted by mini-css-extract-plugin
module.exports = {"input":"TextareaInput_input__KPZpR"};